import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getFolderNameById(value: number): string | undefined {
    const folderMaps =  store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}

const data = {
    filter: {
        title: "childLaunchData",
        pageName: "childLaunchData",
        genre: "childLaunchPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "PATH",
                    field: "fileName",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        let folderMap = "";
                        let path = "";
                        const hasFolderMap = row.folderMapId !== null && row.folderMapId !== undefined;
                        if (row.folderMapId) {
                            folderMap = getFolderNameById(row.folderMapId)?? "";
                        }else{
                            if(!hasFolderMap && row.isFolderMapIdAny){
                                folderMap = "Any";
                            }
                        }
                        if (row.fileName) {
                            path = row.fileName;
                        }
                        let html = "<div class='d-flex flex-column align-items-start'>";

                        html += "<span style='color: #01172F; font-weight: bold;'>" + path + "</span>";
                        html += "<span style='color: #01172F; '>" + folderMap + "</span>";
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";

                        return html;
                    },
                    width: "50%",
                },
                {
                    label: "SECURITY ACTION",
                    field: "allowLaunch",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const securityAction = [];
                        if (row.allowLaunch) {
                            securityAction.push("Allow Launch")
                        }
                        if (row.neverInheritFromParent) {
                            securityAction.push("Never Inherit From Parent")
                        }
                        return (
                            `<ul style="padding-left: 1.25rem; margin: 0; list-style-type: none; color: #01172F;">
                                ${securityAction.map((item) => `<li>${item}</li>`).join("")}</ul>`
                        );
                    },
                    width: "30%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            showPagination:false,
            isLoading: true,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH, {
                    options: options,
                    filters: {}
                });
            },
        },
    },

};

export default data;
